"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortByOptions = exports.showInfoModal = exports.setViewMode = exports.setTopFolderId = exports.setSortBy = exports.setGlobalFilter = exports.setFolders = exports.setFilter = exports.setFiles = exports.setBreadcrumbFolders = exports.selectNext = exports.selectFolder = exports.selectFirstItem = exports.selectFile = exports.renameFolder = exports.renameFile = exports.removeFolder = exports.removeFile = exports.persistedKeys = exports.moveToFolder = exports.loadSubFolders = exports.loadData = exports.initialState = exports.init = exports.goToFolder = exports.goFolderUp = exports["default"] = exports.addFolder = exports.addFile = void 0;
var _reduxActions = require("redux-actions");
var _assets = require("../selectors/assets.js");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _helpers = require("../helpers.js");
var _handleActions;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var Boilerplate = window.cccisd.boilerplate;
var persistedKeys = ['currentFolderId', 'viewMode', 'sortBy'];
exports.persistedKeys = persistedKeys;
var sortByOptions = [{
  value: 'filename',
  label: 'Sort by file name'
}, {
  value: 'newest',
  label: 'Sort by newest'
}];

// Initial state
exports.sortByOptions = sortByOptions;
var initialState = {
  topFolderId: 0,
  currentFolderId: 0,
  folders: [],
  files: [],
  viewMode: 'thumbnail',
  selectedFolderUp: false,
  selectedFiles: [],
  selectedFolders: [2],
  sortBy: 'newest',
  globalFilter: 'none',
  filter: '',
  isInfoModal: false,
  loadedFolders: []
};

// Actions
exports.initialState = initialState;
var INIT = 'resources/assets/INIT';
var SET_TOP_FOLDER_ID = 'resources/assets/SET_TOP_FOLDER_ID';
var GO_TO_FOLDER = 'resources/assets/GO_TO_FOLDER';
var GO_FOLDER_UP = 'resources/assets/GO_FOLDER_UP';
var SET_VIEW_MODE = 'resources/assets/SET_VIEW_MODE';
var SELECT_FILE = 'resources/assets/SELECT_FILE';
var SELECT_FOLDER = 'resources/assets/SELECT_FOLDER';
var SET_FILES = 'resources/assets/SET_FILES';
var SET_FOLDERS = 'resources/assets/SET_FOLDERS';
var SET_SORT_BY = 'resources/assets/SET_SORT_BY';
var SELECT_NEXT = 'resources/assets/SELECT_NEXT';
var SHOW_INFO_MODAL = 'resources/assets/SHOW_INFO_MODAL';
var SET_FILTER = 'resources/assets/SET_FILTER';
var SET_GLOBAL_FILTER = 'resources/assets/SET_GLOBAL_FILTER';
var SELECT_FIRST_ITEM = 'resources/assets/SELECT_FIRST_ITEM';
var SET_BREADCRUMB_FOLDERS = 'resources/assets/SET_BREADCRUMB_FOLDERS';

// Action Creators
var init = (0, _reduxActions.createAction)(INIT);
exports.init = init;
var setTopFolderId = (0, _reduxActions.createAction)(SET_TOP_FOLDER_ID);
exports.setTopFolderId = setTopFolderId;
var goToFolder = (0, _reduxActions.createAction)(GO_TO_FOLDER);
exports.goToFolder = goToFolder;
var goFolderUp = (0, _reduxActions.createAction)(GO_FOLDER_UP);
exports.goFolderUp = goFolderUp;
var setViewMode = (0, _reduxActions.createAction)(SET_VIEW_MODE);
exports.setViewMode = setViewMode;
var selectFile = (0, _reduxActions.createAction)(SELECT_FILE);
exports.selectFile = selectFile;
var selectFolder = (0, _reduxActions.createAction)(SELECT_FOLDER);
exports.selectFolder = selectFolder;
var setFiles = (0, _reduxActions.createAction)(SET_FILES);
exports.setFiles = setFiles;
var setFolders = (0, _reduxActions.createAction)(SET_FOLDERS);
exports.setFolders = setFolders;
var setSortBy = (0, _reduxActions.createAction)(SET_SORT_BY);
exports.setSortBy = setSortBy;
var selectNext = (0, _reduxActions.createAction)(SELECT_NEXT);
exports.selectNext = selectNext;
var showInfoModal = (0, _reduxActions.createAction)(SHOW_INFO_MODAL);
exports.showInfoModal = showInfoModal;
var setFilter = (0, _reduxActions.createAction)(SET_FILTER);
exports.setFilter = setFilter;
var setGlobalFilter = (0, _reduxActions.createAction)(SET_GLOBAL_FILTER);
exports.setGlobalFilter = setGlobalFilter;
var selectFirstItem = (0, _reduxActions.createAction)(SELECT_FIRST_ITEM);
exports.selectFirstItem = selectFirstItem;
var setBreadcrumbFolders = (0, _reduxActions.createAction)(SET_BREADCRUMB_FOLDERS);
exports.setBreadcrumbFolders = setBreadcrumbFolders;
var loadData = function loadData() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    parentId = _ref.parentId,
    _ref$force = _ref.force,
    force = _ref$force === void 0 ? false : _ref$force,
    _ref$initialLoad = _ref.initialLoad,
    initialLoad = _ref$initialLoad === void 0 ? false : _ref$initialLoad,
    selectedFile = _ref.selectedFile;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      var result, fileInfo, state, foldersUrl, response, folders, files;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!selectedFile) {
                _context.next = 6;
                break;
              }
              _context.next = 3;
              return _cccisdAxios["default"].get(Boilerplate.route('api.resources.file.index'), {
                params: {
                  id: selectedFile
                }
              });
            case 3:
              result = _context.sent;
              fileInfo = result.data.data.find(function (item) {
                return item.id === selectedFile;
              });
              if (fileInfo) {
                parentId = fileInfo.folder_id;
              }
            case 6:
              state = getState().resources.assets;
              if (!parentId) {
                parentId = state.currentFolderId;
              }
              if (!(!force && state.loadedFolders.includes(parentId))) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return");
            case 10:
              foldersUrl = parentId ? Boilerplate.route('api.resources.folder.show', {
                folder: parentId
              }) : Boilerplate.route('api.resources.folder.show');
              _context.next = 13;
              return _cccisdAxios["default"].get(foldersUrl);
            case 13:
              response = _context.sent;
              if (!parentId) {
                parentId = response.data.data.self.id;
                dispatch(setTopFolderId(parentId));
              }
              if (initialLoad) {
                dispatch(setBreadcrumbFolders(response.data.data.breadcrumbs));
              }

              // Add folders
              folders = response.data.data.folders.map(function (item) {
                return {
                  id: item.id,
                  name: item.name,
                  path: item.path.replace(/^\/public/, '')
                };
              });
              dispatch(setFolders({
                folders: folders,
                parentId: parentId
              }));

              // Add files
              files = response.data.data.files.map(function (item) {
                // item may not actually be published...
                var file = {
                  id: item.id,
                  name: item.filename,
                  folderId: item.folder_id,
                  size: item.published !== null ? item.published.size : item.draft.size,
                  url: item.published !== null ? item.published.url : item.draft.url,
                  metadata: item.published !== null ? item.published.metadata : item.draft.metadata,
                  updatedAt: item.updated_at
                };
                if (item.thumbnail) {
                  file.thumbnailSmall = item.thumbnail.small_url;
                  file.thumbnailLarge = item.thumbnail.large_url;
                }
                return file;
              }); // if (parentId === 1) {
              //     files = [
              //         ...files,
              //         ...new Array(20).fill(1).map((_, index) => ({
              //             id: index + 1000,
              //             name: `image${index}.png`,
              //             folderId: 0,
              //             size: 123456,
              //             url: `https://placeimg.com/320/240/any?id=${index}`,
              //             updatedAt: '2019-04-12 23:34:12',
              //             thumbnailSmall: `https://placeimg.com/320/240/any?id=${index}`,
              //             thumbnailLarge: `https://placeimg.com/320/240/any?id=${index}`,
              //         })),
              //         {
              //             id: 2000,
              //             name: `sound1.mp3`,
              //             folderId: 0,
              //             size: 123456,
              //             url: `http://www.hochmuth.com/mp3/Bloch_Prayer.mp3`,
              //             updatedAt: '2019-04-12 23:34:15',
              //         },
              //         {
              //             id: 2001,
              //             name: `sound2.mp3`,
              //             folderId: 0,
              //             size: 123456,
              //             url: `http://www.hochmuth.com/mp3/Tchaikovsky_Nocturne__orch.mp3`,
              //             updatedAt: '2019-04-12 23:34:15',
              //         },
              //     ];
              // }
              dispatch(setFiles({
                files: files,
                folderId: parentId
              }));
              if (selectedFile) {
                dispatch(selectFile(selectedFile));
              } else {
                dispatch(selectFirstItem());
              }
            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
exports.loadData = loadData;
var loadSubFolders = function loadSubFolders(folders) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var getAssetsState, loadNext, tree;
      return _regeneratorRuntime().wrap(function _callee3$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              getAssetsState = function getAssetsState() {
                return getState().resources.assets;
              };
              loadNext = /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(folderId, subtree) {
                  var subfolders, _iterator, _step, _loop;
                  return _regeneratorRuntime().wrap(function _callee2$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (getAssetsState().loadedFolders.includes(folderId)) {
                            _context3.next = 3;
                            break;
                          }
                          _context3.next = 3;
                          return dispatch(loadData({
                            parentId: folderId
                          }));
                        case 3:
                          subfolders = getAssetsState().folders.filter(function (item) {
                            return item.parentId === folderId;
                          });
                          _iterator = _createForOfIteratorHelper(subtree);
                          _context3.prev = 5;
                          _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                            var leaf, foundFolder;
                            return _regeneratorRuntime().wrap(function _loop$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    leaf = _step.value;
                                    foundFolder = subfolders.find(function (item) {
                                      return item.name === leaf.name;
                                    });
                                    if (!(foundFolder && leaf.children.length > 0)) {
                                      _context2.next = 5;
                                      break;
                                    }
                                    _context2.next = 5;
                                    return loadNext(foundFolder.id, leaf.children);
                                  case 5:
                                  case "end":
                                    return _context2.stop();
                                }
                              }
                            }, _loop);
                          });
                          _iterator.s();
                        case 8:
                          if ((_step = _iterator.n()).done) {
                            _context3.next = 12;
                            break;
                          }
                          return _context3.delegateYield(_loop(), "t0", 10);
                        case 10:
                          _context3.next = 8;
                          break;
                        case 12:
                          _context3.next = 17;
                          break;
                        case 14:
                          _context3.prev = 14;
                          _context3.t1 = _context3["catch"](5);
                          _iterator.e(_context3.t1);
                        case 17:
                          _context3.prev = 17;
                          _iterator.f();
                          return _context3.finish(17);
                        case 20:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee2, null, [[5, 14, 17, 20]]);
                }));
                return function loadNext(_x5, _x6) {
                  return _ref4.apply(this, arguments);
                };
              }();
              tree = (0, _helpers.foldersToTree)(folders);
              _context4.next = 5;
              return loadNext(getAssetsState().currentFolderId, tree);
            case 5:
              return _context4.abrupt("return", (0, _assets.getAllFiles)(getAssetsState()));
            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee3);
    }));
    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};
exports.loadSubFolders = loadSubFolders;
var addFolder = function addFolder(name) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var state, parentFolder, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state = getState().resources.assets;
              parentFolder = state.currentFolderId === state.topFolderId ? {
                path: ''
              } : state.folders.find(function (item) {
                return item.id === state.currentFolderId;
              });
              if (parentFolder) {
                _context5.next = 4;
                break;
              }
              return _context5.abrupt("return", Promise.reject({
                name: 'There is no current folder'
              }));
            case 4:
              _context5.next = 6;
              return _cccisdAxios["default"].post(Boilerplate.route('api.resources.folder.store'), {
                path: "".concat(parentFolder.path, "/").concat(name)
              });
            case 6:
              response = _context5.sent;
              if (!response.data.errors) {
                _context5.next = 9;
                break;
              }
              return _context5.abrupt("return", Promise.reject((0, _helpers.mapErrors)(response.data.errors, {
                path: 'name'
              })));
            case 9:
              _context5.next = 11;
              return dispatch(loadData({
                force: true
              }));
            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref5.apply(this, arguments);
    };
  }();
};
exports.addFolder = addFolder;
var renameFolder = function renameFolder(id, name) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch, getState) {
      var state, folderInfo, path, response;
      return _regeneratorRuntime().wrap(function _callee5$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              state = getState().resources.assets;
              folderInfo = state.folders.find(function (item) {
                return item.id === id;
              });
              if (folderInfo) {
                _context6.next = 4;
                break;
              }
              return _context6.abrupt("return", Promise.reject({
                name: 'Something wrong'
              }));
            case 4:
              path = folderInfo.path.replace(/\/[^/]+$/, '/' + name);
              _context6.next = 7;
              return _cccisdAxios["default"].put(Boilerplate.route('api.resources.folder.update', {
                folder: id
              }), {
                path: path
              });
            case 7:
              response = _context6.sent;
              if (!response.data.errors) {
                _context6.next = 10;
                break;
              }
              return _context6.abrupt("return", Promise.reject((0, _helpers.mapErrors)(response.data.errors, {
                path: 'name'
              })));
            case 10:
              _context6.next = 12;
              return dispatch(loadData({
                force: true
              }));
            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee5);
    }));
    return function (_x9, _x10) {
      return _ref6.apply(this, arguments);
    };
  }();
};
exports.renameFolder = renameFolder;
var addFile = function addFile(file) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(dispatch, getState) {
      var state, currentFolder, filePath, path, formData, response;
      return _regeneratorRuntime().wrap(function _callee6$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              state = getState().resources.assets;
              currentFolder = {};
              if (state.currentFolderId === state.topFolderId) {
                currentFolder = {
                  path: ''
                };
              } else {
                currentFolder = (0, _assets.getCurrentFolder)(state);
              }
              if (currentFolder) {
                _context7.next = 5;
                break;
              }
              return _context7.abrupt("return", Promise.reject({
                name: 'There is no current folder'
              }));
            case 5:
              filePath = file.path.includes('/') ? file.path.replace(/\/[^/]+$/, '') : '';
              path = "".concat(currentFolder.path).concat(filePath).replace(/^\//, '');
              formData = new FormData();
              if (path) {
                formData.append('path', path);
              }
              formData.append('file', file);
              _context7.next = 12;
              return _cccisdAxios["default"].post(Boilerplate.route('api.resources.file.store'), formData);
            case 12:
              response = _context7.sent;
              _context7.next = 15;
              return dispatch(loadData({
                force: true
              }));
            case 15:
              return _context7.abrupt("return", response);
            case 16:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee6);
    }));
    return function (_x11, _x12) {
      return _ref7.apply(this, arguments);
    };
  }();
};
exports.addFile = addFile;
var renameFile = function renameFile(id, name) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch, getState) {
      var response;
      return _regeneratorRuntime().wrap(function _callee7$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _cccisdAxios["default"].put(Boilerplate.route('api.resources.file.update', {
                file: id
              }), {
                filename: name
              });
            case 2:
              response = _context8.sent;
              if (!response.data.errors) {
                _context8.next = 5;
                break;
              }
              return _context8.abrupt("return", Promise.reject(response.data.errors));
            case 5:
              _context8.next = 7;
              return dispatch(loadData({
                force: true
              }));
            case 7:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee7);
    }));
    return function (_x13, _x14) {
      return _ref8.apply(this, arguments);
    };
  }();
};
exports.renameFile = renameFile;
var removeFile = function removeFile(id) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(dispatch, getState) {
      var state, files;
      return _regeneratorRuntime().wrap(function _callee8$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 1000);
              });
            case 2:
              state = getState().resources.assets;
              files = state.files.filter(function (item) {
                return item.folderId === state.currentFolderId;
              });
              dispatch(setFiles({
                files: files.filter(function (file) {
                  return file.id !== id;
                })
              }));
            case 5:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee8);
    }));
    return function (_x15, _x16) {
      return _ref9.apply(this, arguments);
    };
  }();
};
exports.removeFile = removeFile;
var removeFolder = function removeFolder(id) {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(dispatch, getState) {
      var state, folders;
      return _regeneratorRuntime().wrap(function _callee9$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 1000);
              });
            case 2:
              state = getState().resources.assets;
              folders = state.folders.filter(function (item) {
                return item.parentId === state.currentFolderId;
              });
              dispatch(setFolders({
                folders: folders.filter(function (folder) {
                  return folder.id !== id;
                })
              }));
            case 5:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee9);
    }));
    return function (_x17, _x18) {
      return _ref10.apply(this, arguments);
    };
  }();
};
exports.removeFolder = removeFolder;
var moveToFolder = function moveToFolder(destId) {
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(dispatch, getState) {
      var state, destFolder, _iterator2, _step2, _loop2, _iterator3, _step3, sourceId;
      return _regeneratorRuntime().wrap(function _callee10$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              state = getState().resources.assets;
              destFolder = state.folders.find(function (item) {
                return item.id === destId;
              });
              _iterator2 = _createForOfIteratorHelper(state.selectedFolders);
              _context12.prev = 3;
              _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
                var sourceId, sourceFolder, newPath;
                return _regeneratorRuntime().wrap(function _loop2$(_context11) {
                  while (1) {
                    switch (_context11.prev = _context11.next) {
                      case 0:
                        sourceId = _step2.value;
                        sourceFolder = state.folders.find(function (item) {
                          return item.id === sourceId;
                        });
                        newPath = destFolder.path + '/' + sourceFolder.name;
                        _context11.next = 5;
                        return _cccisdAxios["default"].put(Boilerplate.route('api.resources.folder.update', {
                          folder: sourceId
                        }), {
                          path: newPath
                        });
                      case 5:
                      case "end":
                        return _context11.stop();
                    }
                  }
                }, _loop2);
              });
              _iterator2.s();
            case 6:
              if ((_step2 = _iterator2.n()).done) {
                _context12.next = 10;
                break;
              }
              return _context12.delegateYield(_loop2(), "t0", 8);
            case 8:
              _context12.next = 6;
              break;
            case 10:
              _context12.next = 15;
              break;
            case 12:
              _context12.prev = 12;
              _context12.t1 = _context12["catch"](3);
              _iterator2.e(_context12.t1);
            case 15:
              _context12.prev = 15;
              _iterator2.f();
              return _context12.finish(15);
            case 18:
              _iterator3 = _createForOfIteratorHelper(state.selectedFiles);
              _context12.prev = 19;
              _iterator3.s();
            case 21:
              if ((_step3 = _iterator3.n()).done) {
                _context12.next = 27;
                break;
              }
              sourceId = _step3.value;
              _context12.next = 25;
              return _cccisdAxios["default"].put(Boilerplate.route('api.resources.file.update', {
                file: sourceId
              }), {
                folderId: destId
              });
            case 25:
              _context12.next = 21;
              break;
            case 27:
              _context12.next = 32;
              break;
            case 29:
              _context12.prev = 29;
              _context12.t2 = _context12["catch"](19);
              _iterator3.e(_context12.t2);
            case 32:
              _context12.prev = 32;
              _iterator3.f();
              return _context12.finish(32);
            case 35:
              _context12.next = 37;
              return dispatch(loadData({
                force: true
              }));
            case 37:
              _context12.next = 39;
              return dispatch(loadData({
                parentId: destId,
                force: true
              }));
            case 39:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee10, null, [[3, 12, 15, 18], [19, 29, 32, 35]]);
    }));
    return function (_x19, _x20) {
      return _ref11.apply(this, arguments);
    };
  }();
};

// Reducer
exports.moveToFolder = moveToFolder;
var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, INIT, function (state, action) {
  return _objectSpread(_objectSpread({}, state), (0, _pick2["default"])(initialState, ['topFolderId', 'currentFolderId', 'folders', 'files', 'selectedFolderUp', 'selectedFiles', 'selectedFolders', 'globalFilter', 'filter', 'isInfoModal', 'loadedFolders']));
}), _defineProperty(_handleActions, SET_TOP_FOLDER_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    topFolderId: action.payload,
    currentFolderId: action.payload
  });
}), _defineProperty(_handleActions, GO_TO_FOLDER, function (state, action) {
  if (state.isInfoModal) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    currentFolderId: action.payload,
    selectedFolderUp: true,
    selectedFiles: [],
    selectedFolders: []
  });
}), _defineProperty(_handleActions, GO_FOLDER_UP, function (state, action) {
  if (state.currentFolderId === state.topFolderId || state.isInfoModal) {
    return state;
  }
  var currentFolder = state.folders.find(function (item) {
    return item.id === state.currentFolderId;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    currentFolderId: currentFolder.parentId,
    selectedFolderUp: false,
    selectedFiles: [],
    selectedFolders: [state.currentFolderId]
  });
}), _defineProperty(_handleActions, SET_VIEW_MODE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    viewMode: action.payload
  });
}), _defineProperty(_handleActions, SELECT_FILE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedFolderUp: false,
    selectedFiles: [action.payload],
    selectedFolders: []
  });
}), _defineProperty(_handleActions, SELECT_FOLDER, function (state, action) {
  if (action.payload === -1) {
    return _objectSpread(_objectSpread({}, state), {}, {
      selectedFolderUp: true,
      selectedFiles: [],
      selectedFolders: []
    });
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedFolderUp: false,
    selectedFiles: [],
    selectedFolders: [action.payload]
  });
}), _defineProperty(_handleActions, SET_FILES, function (state, action) {
  var _action$payload = action.payload,
    files = _action$payload.files,
    folderId = _action$payload.folderId;
  if (folderId === undefined) {
    folderId = state.currentFolderId;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    files: [].concat(_toConsumableArray(state.files.filter(function (file) {
      return file.folderId !== folderId;
    })), _toConsumableArray(files.map(function (file) {
      return _objectSpread(_objectSpread({}, file), {}, {
        folderId: folderId
      });
    })))
  });
}), _defineProperty(_handleActions, SET_FOLDERS, function (state, action) {
  var _action$payload2 = action.payload,
    folders = _action$payload2.folders,
    parentId = _action$payload2.parentId;
  if (parentId === undefined) {
    parentId = state.currentFolderId;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    folders: [].concat(_toConsumableArray(state.folders.filter(function (folder) {
      return folder.parentId !== parentId;
    })), _toConsumableArray(folders.map(function (folder) {
      return _objectSpread(_objectSpread({}, folder), {}, {
        parentId: parentId
      });
    }))),
    loadedFolders: state.loadedFolders.includes(parentId) ? state.loadedFolders : [].concat(_toConsumableArray(state.loadedFolders), [parentId])
  });
}), _defineProperty(_handleActions, SET_SORT_BY, function (state, action) {
  if (!sortByOptions.find(function (item) {
    return item.value === action.payload;
  })) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    sortBy: action.payload
  });
}), _defineProperty(_handleActions, SELECT_NEXT, function (state, action) {
  var currentFolderId = state.currentFolderId,
    topFolderId = state.topFolderId,
    selectedFolderUp = state.selectedFolderUp,
    isInfoModal = state.isInfoModal;
  var _getCurrentFolderData = (0, _assets.getCurrentFolderData)(state),
    folders = _getCurrentFolderData.folders,
    files = _getCurrentFolderData.files;
  var oneSelectedFile = (0, _assets.getOneSelectedFile)(state);
  var oneSelectedFolder = (0, _assets.getOneSelectedFolder)(state);
  var items = [{
    id: -1
  }].concat(_toConsumableArray(folders), _toConsumableArray(files));
  var steps = action.payload || 1;
  if (!oneSelectedFolder && !oneSelectedFile && !selectedFolderUp) {
    return state;
  }
  var newIndex = 0;
  if (oneSelectedFolder) {
    newIndex = folders.findIndex(function (item) {
      return item.id === oneSelectedFolder.id;
    }) + 1;
  } else if (oneSelectedFile) {
    newIndex = files.findIndex(function (item) {
      return item.id === oneSelectedFile.id;
    }) + 1 + folders.length;
  }
  newIndex += steps;
  var foundItem = items[newIndex];
  if (!foundItem) {
    return state;
  }

  // if folderUp
  if (foundItem.id === -1) {
    return currentFolderId === topFolderId || isInfoModal ? state : _objectSpread(_objectSpread({}, state), {}, {
      selectedFolderUp: true,
      selectedFolders: [],
      selectedFiles: []
    });
  }

  // if folder
  if (foundItem.parentId !== undefined) {
    return _objectSpread(_objectSpread({}, state), {}, {
      selectedFolderUp: false,
      selectedFolders: [foundItem.id],
      selectedFiles: []
    });
  }

  // if file
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedFolderUp: false,
    selectedFolders: [],
    selectedFiles: [foundItem.id]
  });
}), _defineProperty(_handleActions, SHOW_INFO_MODAL, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isInfoModal: action.payload === false ? false : true
  });
}), _defineProperty(_handleActions, SET_FILTER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    filter: action.payload,
    selectedFolders: [],
    selectedFiles: []
  });
}), _defineProperty(_handleActions, SET_GLOBAL_FILTER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    globalFilter: action.payload
  });
}), _defineProperty(_handleActions, SELECT_FIRST_ITEM, function (state, action) {
  var currentFolderId = state.currentFolderId,
    topFolderId = state.topFolderId;
  var _getCurrentFolderData2 = (0, _assets.getCurrentFolderData)(state),
    folders = _getCurrentFolderData2.folders,
    files = _getCurrentFolderData2.files;
  var isAnySelected = (0, _assets.getIsAnySelected)(state);
  if (isAnySelected) {
    return state;
  }
  if (currentFolderId !== topFolderId) {
    return _objectSpread(_objectSpread({}, state), {}, {
      selectedFolderUp: true,
      selectedFolders: [],
      selectedFiles: []
    });
  }
  if (folders.length > 0) {
    return _objectSpread(_objectSpread({}, state), {}, {
      selectedFolders: [folders[0].id]
    });
  }
  if (files.length > 0) {
    return _objectSpread(_objectSpread({}, state), {}, {
      selectedFiles: [files[0].id]
    });
  }
  return state;
}), _defineProperty(_handleActions, SET_BREADCRUMB_FOLDERS, function (state, action) {
  var existingFolderIds = state.folders.map(function (item) {
    return item.id;
  });
  var topFolder = action.payload.find(function (item) {
    return !item.parent_id;
  });
  var currentFolder = (0, _last2["default"])(action.payload);
  return _objectSpread(_objectSpread(_objectSpread({}, state), {}, {
    folders: [].concat(_toConsumableArray(state.folders), _toConsumableArray(action.payload.filter(function (item) {
      return !existingFolderIds.includes(item.id) && item.parent_id;
    }).map(function (item) {
      return {
        id: item.id,
        name: item.name,
        path: item.path.replace(/^\/public/, ''),
        parentId: item.parent_id
      };
    })))
  }, topFolder && {
    topFolderId: topFolder.id
  }), {}, {
    currentFolderId: currentFolder.id
  });
}), _handleActions), initialState);
exports["default"] = _default;